import React from 'react';
import PropTypes from 'prop-types'; 
import './_lista.css';
import Avatar from '../Avatar';
import Info from '../Info';
import Badge from '../Badge';

const ListaItem = (props)=>{


    return(
        <div>
            <div className="list-item-container"
                onClick={()=>props.onClick()} 
                style={{backgroundColor : props.highlight ? '#fff':null}}>
                { props.avatar && <Avatar src={props.avatar} style={{ marginRight: 10 }}/> }
                <Info 
                    style={{flex: 1, maxWidth: 225, whiteSpace: 'nowrap', overflow: 'hidden', paddingRight: 5}}
                    title={props.titulo}
                    tag={props.tag}
                    subtitle={props.subTitulo}
                    subtitleStyle={{fontSize: 16}}
                />
                <div className="list-item-status">
                    <p>{props.data}</p>
                    {props.messageNotification && <Badge style={{ marginTop: 5 }}/>}
                </div>
            </div>
            <div className="list-item-container-border-bottom-item">
                <div className="list-item-container-border-bottom"></div>
            </div>
        </div>
    )
}

ListaItem.propTypes = {
    avatar : PropTypes.string,
    titulo : PropTypes.string.isRequired,
    subTitulo : PropTypes.string,
    data : PropTypes.string,
    messageNotification : PropTypes.bool,
    onClick : PropTypes.func,
}

ListaItem.defaultProps = {
    onClick : ()=>{},
}

export default ListaItem;


// WEBPACK FOOTER //
// ./src/components/lista/Lista-item.js